import { defineMessages } from 'react-intl';

export default defineMessages({
  deleteCheckoutRateModalTitle: {
    description: 'Checkout Rates Delete Modal Title',
    defaultMessage: 'Delete Checkout Rate',
    id: 'J/kAwC',
  },
  deleteFulfillmentRateModalTitle: {
    description: 'Fulfillment Rates Delete Modal Title',
    defaultMessage: 'Delete Fulfillment Rate',
    id: '2Abh9f',
  },
  delete: {
    description: 'Delivery Options, Delete Button',
    defaultMessage: 'Delete',
    id: 'HfBxlT',
  },
  deleting: {
    description: 'Delivery Options, Deleting Button',
    defaultMessage: 'Deleting...',
    id: 's+IXMj',
  },
  cancel: {
    description: 'Delivery Options, Cancel Button',
    defaultMessage: 'Cancel',
    id: 'MBh25l',
  },
  deleteWarningMessage: {
    description: 'Delivery Options, Delete Warning Message',
    defaultMessage: 'Are you sure you want to permanently delete {itemName}? This action cannot be undone',
    id: 'Ecaeft',
  },
});
